<template>
  <Layout>
    <div class="row">
      <!-- accident Alert -->
      <b-modal id="accident-modal" centered hide-footer size="sm">
        <div class="d-block text-center mb-3">
          <h3>New Accident Alert</h3>
        </div>
        <hr />
        <div class="text-center">
          <b-button class="mt-2" variant="outline-warning" block @click="playAccidentSound()" text-center>Ok</b-button>
        </div>
      </b-modal>

      <!-- Incident Alert -->
      <b-modal id="incident-modal" centered hide-footer size="sm">
        <div class="d-block text-center mb-3">
          <h3>New Incident Alert</h3>
        </div>
        <hr />
        <div class="text-center">
          <b-button class="mt-2" variant="outline-warning" block @click="playIncidentSound()" text-center>Ok</b-button>
        </div>
      </b-modal>

      <!-- DEVICE STATUS -->
      <div class="col-6" v-for="(device, i) in devices" :key="i">
        <div class="card mini-stats-wid device-card" @click="showDevice(device)">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-12 text-center" style="padding: 0; margin: 0">
                <i :class="getDeviceIcon(device.name)" style="margin-right: 5px"></i>
                <small class="text-muted" style="font-size: 10px">{{
                  getDeviceName(device.name)
                }}</small>
              </div>

              <div :class="`col-lg-6 col-12 text-center font-size-14 ${getDeviceClass(
                    device.status
                  )}`">
                <small style="font-size: 14px">{{
                  getDeviceStatus(device.status)
                }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ACCIDENTS & INCIDENTS -->
    <div>
      <div class="row">
        <b-tabs pills justified content-class="text-muted" class="mobileView">
          <!-- Accidents tab details -->
          <b-tab active>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none"> Accidents </span>
              <span class="d-none d-sm-inline-block">Accidents</span>
            </template>

            <div class="col-12 mt-2">
              <!-- Active Assigned Incident -->
              <div v-if="activeAccidents.length > 0">
                <carousel :per-page="1" :mouse-drag="false">
                  <slide v-for="(accident, index) in activeAccidents" :key="index">
                    <div class="card m-2">
                      <div class="card-body glow-div">
                        <p>Accident Id : {{ accident.id }}</p>
                        <p>{{ $t("app.chainageNo") }} : {{ accident.ch_no }}</p>
                        <p>
                          Side:
                          {{ accident.side }}
                        </p>
                        <p>
                          {{ $t("app.dateTime") }} :
                          {{
                            new Date(
                              accident.reported_datetime
                            ).toLocaleString()
                          }}
                        </p>
                        <p>
                          RPO Status :
                          {{
                            (accident.rpo_response) ? accident.rpo_response : 'Waiting for response...'
                          }}
                        </p>
                        <div class="row">
                          <div class="col-4 m-0 p-1" v-if="!accident.rpo_response">
                            <b-button @click="denyIncident(accident.id, 'accident')" style="height: 75px;"
                              variant="secondary" class="w-100 m-0 p-0">
                              <span style="font-size: 15px;">Decline</span>
                            </b-button>
                          </div>
                          <div class="col-8 m-0 p-1" v-if="!accident.rpo_response">
                            <b-button @click="acceptIncident(accident, accident.id, 'accident')" style="height: 75px;"
                              variant="success" class="w-100 m-0 p-0">
                              <span style="font-size: 15px;">Accept and Start</span>
                            </b-button>
                          </div>
                          <div class="col-12" v-if="accident.rpo_response && accident.rpo_response === 'accepted'">
                            <router-link :to="`/phone/incident/${accident.id}`">
                              <b-button variant="primary" class="col-12">
                                Show Details
                              </b-button>
                            </router-link>
                          </div>
                          <!-- 
                          <div class="col-6">
                            <router-link :to="`/phone/report/${accident.id}`">
                              <b-button size="sm" variant="danger" class="col-12">
                                {{ $t("app.report") }}
                              </b-button>
                            </router-link>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </slide>
                </carousel>
              </div>
              <div class="text-center no-active-card" v-else>
                <p class="m-5 p-5">{{ $t("app.noActiveAccident") }}</p>
              </div>
            </div>
          </b-tab>

          <!-- incidents tab details -->
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none"> Incidents </span>
              <span class="d-none d-sm-inline-block">Incidents</span>
            </template>

            <div class="col-12 mt-2">
              <!-- Active Assigned Incident -->
              <div v-if="activeIncidents.length > 0">
                <carousel :per-page="1" :mouse-drag="false">
                  <slide v-for="(incident, index) in activeIncidents" :key="index">
                    <div class="card m-2">
                      <div class="card-body glow-incident-div">
                        <p>Incident Id : {{ incident.id }}</p>
                        <p>{{ $t("app.chainageNo") }} : {{ incident.ch_no }}</p>
                        <p>
                          Side :
                          {{ incident.side }}
                        </p>
                        <p>
                          {{ $t("app.dateTime") }} :
                          {{
                            new Date(
                              incident.reported_datetime
                            ).toLocaleString()
                          }}
                        </p>
                        <p>
                          RPO Status :
                          {{
                            (incident.rpo_response) ? incident.rpo_response : 'Waiting for response...'
                          }}
                        </p>
                        <div class="row">
                          <div class="col-4 m-0 p-1" v-if="!incident.rpo_response">
                            <b-button @click="denyIncident(incident.id, 'incident')" style="height: 75px;"
                              variant="secondary" class="w-100 m-0 p-0">
                              <span style="font-size: 15px;">Decline</span>
                            </b-button>
                          </div>
                          <div class="col-8 m-0 p-1" v-if="!incident.rpo_response">
                            <b-button @click="acceptIncident(incident, incident.id, 'incident')" style="height: 75px;"
                              variant="success" class="w-100 m-0 p-0">
                              <span style="font-size: 15px;">Accept and Start</span>
                            </b-button>
                          </div>
                        </div>
                        <div class="col-12" v-if="incident.rpo_response && incident.rpo_response === 'accepted'">
                          <router-link :to="`/phone/incident/${incident.id}`">
                            <b-button variant="primary" class="col-12">
                              Show Details
                            </b-button>
                          </router-link>
                        </div>
                        <!-- <div class="row">
                          <div class="col-6">
                            <router-link :to="`/phone/report/${incident.id}`">
                              <b-button
                                size="sm"
                                variant="danger"
                                class="col-12"
                              >
                                {{ $t("app.report") }}
                              </b-button>
                            </router-link>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </slide>
                </carousel>
              </div>
              <!-- No incident assigned yet -->
              <div class="text-center no-active-card" v-else>
                <p class="m-5 p-5">{{ $t("app.noActiveIncident") }}</p>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="row footer-raise-btn-holder" v-if="activeIncidents.length === 0">
        <div class="col-12">
          <router-link to="/phone/raise-incident">
            <b-button variant="primary" class="w-100">
              {{ $t("app.raiseIncident") }} <i class="fa fa-rocket"></i>
            </b-button>
          </router-link>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import { Carousel, Slide } from "vue-carousel";
import Swal from "sweetalert2";
import incidentMixin from '@/mixins/incident'

/**
 * Dashboard Component
 */
export default {
  data () {
    return {
      isAccidentModalActive: false,
      isIncidentModalActive: false,
      accidentAudioReplay: null,
      incidentAudioReplay: null,
      buttonStatus: false,
      latestIncident: [],
      latestAccident: [],
    };
  },
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [incidentMixin],

  components: {
    Layout,
    Carousel,
    Slide,
  },

  async mounted () {

    await this.GetAllMasterData()

    this.$store.dispatch("gis/setDevices", [
      { name: "front_camera_url", status: "LOADING" },
      { name: "rear_camera_url", status: "LOADING" },
      { name: "body_camera_url", status: "LOADING" },
      { name: "GPS", status: "LOADING" },
    ]);

    setTimeout(() => {
      // eslint-disable-next-line no-undef
      new JSMpeg.Player(`wss://adastest.transharyana.in:${data.port}`, {
        canvas: document.getElementById("canvas"),
      });
    }, 3000);

    this.sockets.subscribe("RPO_DEVICES", (data) => {
      let devices = [];
      Object.keys(data).forEach((device) => {
        if (
          device === "front_camera_url" ||
          device === "rear_camera_url" ||
          device === "body_camera_url"
        ) {
          devices.push({ name: device, url: data[device] });
        }
      });

      // eslint-disable-next-line no-undef
      ReactNativeWebView.postMessage(
        JSON.stringify({
          command: "DEVICE_STATUS",
          data: JSON.stringify(devices),
        })
      );
    });

    setInterval(() => {
      this.$socket.emit(
        "REQUEST:RPO_DEVICES",
        JSON.stringify({ userId: this.currentUser.user.id })
      );

      this.$socket.emit(
        "REQUEST:RPO_ACTIVE_ASSIGNED_INCIDENTS",
        JSON.stringify({ userId: this.currentUser.user.id })
      );

      this.$socket.emit(
        "ADAS:SET_RPO_LIVE_DETAILS",
        JSON.stringify({
          devices: this.devices,
          id: this.currentUser.user.id,
        })
      );

      // alert(JSON.stringify(this.incidents));
    }, 5000);
  },

  methods: {
    // playAccidentSound() {
    //   if (this.buttonStatus === false) {
    //     this.$bvModal.show("accident-modal");
    //     // accidentAudio.play();
    //     this.buttonStatus = true;
    //   } else {
    //     // accidentAudio.pause();
    //     accidentAudio.currentTime = 0;
    //     this.buttonStatus = false;
    //     this.$bvModal.hide("accident-modal");
    //   }
    // },

    // playIncidentSound() {
    //   if (this.buttonStatus === false) {
    //     this.$bvModal.show("incident-modal");
    //     // incidentAudio.play();
    //     this.buttonStatus = true;
    //   } else {
    //     // incidentAudio.pause();
    //     incidentAudio.currentTime = 0;
    //     this.buttonStatus = false;
    //     this.$bvModal.hide("incident-modal");
    //   }
    // },

    async acceptIncident (incident, incidentId, type) {
      try {
        await this.Respond({
          rpoName: `${this.currentUser.user.first_name} ${this.currentUser.user.last_name}`,
          response: 'accepted',
          incidentType: type,
          incidentId: incidentId
        })

        Swal.fire({
          icon: 'success',
          title: 'Response Recorded',
          text: 'Your response is recorded by control room',
          timer: 3000,
          showConfirmButton: false,
          showDenyButton: false
        })

        this.selectedIncident = incident;
        this.$router.push({
          name: "phone-incident-report",
          params: {
            data: this.selectedIncident,
          },
        });
      } catch (e) {
        Swal.fire('Failed!', e.response.data.message, 'error')
      }
    },

    async denyIncident (incidentId, type) {
      try {
        await this.Respond({
          rpoName: `${this.currentUser.user.first_name} ${this.currentUser.user.last_name}`,
          response: 'denied',
          incidentType: type,
          incidentId: incidentId
        })

        Swal.fire({
          icon: 'success',
          title: 'Response Recorded',
          text: 'Your response is recorded by control room',
          timer: 3000,
          showConfirmButton: false,
          showDenyButton: false
        })
      } catch (e) {
        Swal.fire('Failed!', e.response.data.message, 'error')
      }
    },

    showReportIncidentPage (accident) {
      this.selectedIncident = accident;
      this.$router.push({
        name: "phone-incident-report",
        params: {
          data: this.selectedIncident,
        },
      });
    },

    showDevice (device) {
      if (device.url) {
        this.$router.push({
          name: "phone-device",
          params: { device: { ...device } },
        });
      }
    },

    TriggerAccidentModal () {
      if (
        this.activeAccidents &&
        this.activeAccidents.length > 0 &&
        !this.isAccidentModalActive
      ) {
        this.isAccidentModalActive = true;
        let audio = new Audio("/accident.wav");
        audio.play();

        this.accidentAudioReplay = setInterval(() => {
          audio.currentTime = 0;
          audio.play();
        }, 5000);

        Swal.fire({
          title: "Accident Alert",
          text: "New Accident Assigned",
          icon: "warning",
          confirmButtonText: "Ok",
        }).then(() => {
          this.isAccidentModalActive = false;
          clearInterval(this.accidentAudioReplay);
        });
      }
    },

    TriggerIncidentModal () {
      if (
        this.activeIncidents &&
        this.activeIncidents.length > 0 &&
        !this.isAccidentModalActive &&
        !this.isIncidentModalActive
      ) {
        this.isIncidentModalActive = true;

        let audio = new Audio("/incident.wav");
        audio.play();

        this.incidentAudioReplay = setInterval(() => {
          audio.currentTime = 0;
          audio.play();
        }, 2000);
        Swal.fire({
          title: "Incident Alert",
          text: "New Incident Assigned",
          icon: "warning",
          confirmButtonText: "Ok",
        }).then(() => {
          this.isIncidentModalActive = false;
          clearInterval(this.incidentAudioReplay);
        });
      }
    },

    getDeviceIcon (deviceCodeName) {
      switch (deviceCodeName) {
        case "front_camera_url":
          return "fas fa-video";

        case "rear_camera_url":
          return "fas fa-video";

        case "body_camera_url":
          return "fas fa-camera";

        case "GPS":
          return "fas fa-location-arrow";

        default:
          return deviceCodeName;
      }
    },

    getDeviceName (deviceCodeName) {
      switch (deviceCodeName) {
        case "front_camera_url":
          return "Front Cam";

        case "rear_camera_url":
          return "Rear Cam";

        case "body_camera_url":
          return "Body Cam";

        case "GPS":
          return "Location";

        default:
          return deviceCodeName;
      }
    },

    getDeviceStatus (status) {
      switch (status) {
        case true:
          return "ONLINE";

        case false:
          return "OFFLINE";

        case "LOADING":
          return "LOADING";

        default:
          return "UNKNOWN";
      }
    },

    getDeviceClass (status) {
      switch (status) {
        case true:
          return "text-success";

        case false:
          return "text-danger";

        default:
          return "text-warning";
      }
    },
  },

  computed: {
    incidents () {
      return this.$store.getters["socket/incident"];
    },
    activeAccidents () {
      return this.incidents.activeAccidents.filter(a => !a.rpo_response || a.rpo_response === 'accepted')
    },
    activeIncidents () {
      return this.incidents.activeIncidents.filter(a => !a.rpo_response || a.rpo_response === 'accepted')
    },
    accidentCount () {
      return this.activeAccidents.length;
    },
    incidentCount () {
      return this.activeIncidents.length;
    },
    currentUser () {
      return this.$store.getters["auth/user"];
    },
    devices () {
      return this.$store.getters["gis/devices"];
    },
  },

  watch: {
    accidentCount: function () {
      this.TriggerAccidentModal();
    },
    incidentCount: function () {
      if (!this.isAccidentModalActive) {
        this.TriggerIncidentModal();
      }
    },
  },
};
</script>
<style>
.no-active-card {
  border-radius: 15px;
  background: #1f2331;
  box-shadow: inset 20px 20px 40px #171a25, inset -20px -20px 40px #272c3d;
}

.footer-raise-btn {
  border: none;
  border-radius: 10px;
  width: 96%;
}

.footer-raise-btn-holder {
  position: fixed;
  bottom: 80px;
  width: 100%;
}

.VueCarousel-dot-container {
  margin-top: -30px !important;
}

.VueCarousel-dot--active {
  margin-top: 0px !important;
}

.glow-div {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  border: none;
  color: white;
  -webkit-animation: accidentGlowing 1500ms infinite;
  -moz-animation: accidentGlowing 1500ms infinite;
  -o-animation: accidentGlowing 1500ms infinite;
  animation: accidentGlowing 1500ms infinite;
}

@-webkit-keyframes accidentGlowing {
  0% {
    background-color: #680000ea;
    -webkit-box-shadow: 0 0 3px #680000ea;
  }

  25% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }

  50% {
    background-color: #dd0000;
    -webkit-box-shadow: 0 0 10px #dd0000;
  }

  75% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }

  100% {
    background-color: #680000ea;
    -webkit-box-shadow: 0 0 3px #680000ea;
  }
}

@-moz-keyframes accidentGlowing {
  0% {
    background-color: #680000ea;
    -webkit-box-shadow: 0 0 3px #680000ea;
  }

  25% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }

  50% {
    background-color: #dd0000;
    -webkit-box-shadow: 0 0 10px #dd0000;
  }

  75% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }

  100% {
    background-color: #680000ea;
    -webkit-box-shadow: 0 0 3px #680000ea;
  }
}

@-o-keyframes accidentGlowing {
  0% {
    background-color: #680000ea;
    -webkit-box-shadow: 0 0 3px #680000ea;
  }

  25% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }

  50% {
    background-color: #dd0000;
    -webkit-box-shadow: 0 0 10px #dd0000;
  }

  75% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }

  100% {
    background-color: #680000ea;
    -webkit-box-shadow: 0 0 3px #680000ea;
  }
}

@keyframes accidentGlowing {
  0% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }

  25% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }

  50% {
    background-color: #dd0000;
    -webkit-box-shadow: 0 0 10px #dd0000;
  }

  75% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }

  100% {
    background-color: #900000ea;
    -webkit-box-shadow: 0 0 3px #900000ea;
  }
}

.glow-incident-div {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  border: none;
  color: white;
  -webkit-animation: incidentGlowing 1500ms infinite;
  -moz-animation: incidentGlowing 1500ms infinite;
  -o-animation: incidentGlowing 1500ms infinite;
  animation: incidentGlowing 1500ms infinite;
}

@-webkit-keyframes incidentGlowing {
  0% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }

  25% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 10px #ff8800;
  }

  50% {
    background-color: #ffbb33;
    -webkit-box-shadow: 0 0 10px #ffbb33;
  }

  75% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 10px #ff8800;
  }

  100% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }
}

@-moz-keyframes incidentGlowing {
  0% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }

  25% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 10px #ff8800;
  }

  50% {
    background-color: #ffbb33;
    -webkit-box-shadow: 0 0 10px #ffbb33;
  }

  75% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 10px #ff8800;
  }

  100% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }
}

@-o-keyframes incidentGlowing {
  0% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }

  25% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 10px #ff8800;
  }

  50% {
    background-color: #ffbb33;
    -webkit-box-shadow: 0 0 10px #ffbb33;
  }

  75% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 10px #ff8800;
  }

  100% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }
}

@keyframes incidentGlowing {
  0% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }

  25% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 10px #ff8800;
  }

  50% {
    background-color: #ffbb33;
    -webkit-box-shadow: 0 0 10px #ffbb33;
  }

  75% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 10px #ff8800;
  }

  100% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }
}

.device-card {
  border-radius: 10px;
  background: linear-gradient(145deg, #1f2331, #242a3a);
  box-shadow: 2px 2px 2px #1c202c, -2px -2px 2px #282e40;
}

.col-style {
  padding-right: 5px !important;
  padding-left: 2px !important;
}

.nav-link {
  border-radius: 10px !important;
  background: linear-gradient(145deg, #1f2331, #242a3a);
  box-shadow: 2px 2px 2px #1c202c, -2px -2px 2px #282e40;
}

.nav-justified>.nav-link,
.nav-justified .nav-item {
  margin-right: 5px;
  margin-left: 5px;
}

/* .VueCarousel-wrapper {
  -webkit-box-ordinal-group: 3 !important;
  order: 2 !important;
} */

.VueCarousel-pagination {
  position: fixed;
  bottom: 90px;
  right: 5px;
  left: 5px;
  /* -webkit-box-ordinal-group: 2 !important;
  order: 1 !important; */
}

.fix-footer {
  position: fixed;
  bottom: 80px;
  right: 5px;
  left: 5px;
}
</style>
